import React, { useEffect, useState } from "react";
import * as Animate from "react-reveal";
import EmptySchoolList from "../../../components/blocks/EmptySchoolList";
import { getCohortsApi } from "../../../store/actions";
import CourseCard from "./CourseCard";
import CourseCard2 from "./CourseCard2";

const CoursesSection = ({ selectedLocation, selectedSchoolData }) => {
  const [cohortData, setCohortData] = useState({});
  const [cohortLoading, setCohortLoading] = useState(false);
  const fetchCohortDateData = async () => {
    setCohortLoading(true);
    try {
      const params = { page: 1, limit: 1 };
      const response = await getCohortsApi(params);
      setCohortData(response?.data?.[0] || {});
      setCohortLoading(false);
    } catch (error) {
      setCohortLoading(false);
    }
  };

  useEffect(() => {
    fetchCohortDateData();
  }, []);

  return (
    <section className="courses-available h-100 py-24">
      <div className="container px-4 mx-auto">
        <div className="w-full lg:w-8/12 xl:w-10/12">
          <Animate.Fade bottom>
            <h2 className="w-full lg:w-8/12 text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-bold">
              Courses available in Utiva {selectedSchoolData?.name}{" "}
            </h2>

            <p className="mt-6 text-sm-15 lg:text-base xl:text-lg lg:leading-7 w-full">
              Utiva offers a wide variety of programs and courses led by leading
              industry experts.
            </p>
          </Animate.Fade>
        </div>

        {selectedSchoolData.courses?.length > 0 ? (
          <>
            {selectedLocation?.name === "Africa" || !selectedLocation ? (
              <div className="mt-14 lg:mt-20 grid grid-cols-1 gap-y-12">
                {selectedSchoolData.courses.map((course, index) => (
                  <React.Fragment key={index}>
                    <Animate.Fade bottom>
                      <CourseCard
                        course={course}
                        cohortData={cohortData}
                        cohortLoading={cohortLoading}
                      />
                    </Animate.Fade>
                  </React.Fragment>
                ))}
              </div>
            ) : (
              <div className="mt-14 lg:mt-20 grid grid-cols-1 gap-x-8 gap-y-12">
                {selectedSchoolData.courses.map((course, index) => (
                  <React.Fragment key={index}>
                    <Animate.Fade bottom>
                      <CourseCard2
                        course={course}
                        selectedLocation={selectedLocation}
                        cohortData={cohortData}
                        cohortLoading={cohortLoading}
                      />
                    </Animate.Fade>
                  </React.Fragment>
                ))}
              </div>
            )}
          </>
        ) : (
          <EmptySchoolList />
        )}
      </div>
    </section>
  );
};

export default CoursesSection;
